export const reasonRecordStatus = [
  { key: "O", badgeColor: "success", name: "Hoạt động" },
  { key: "C", badgeColor: "danger", name: "Đã đóng" },
];
